/* tslint:disable */

declare var Object: any;
export interface SFSmartfeedInterface {
  "id"?: number;
}

export class SFSmartfeed implements SFSmartfeedInterface {
  "id": number;
  constructor(data?: SFSmartfeedInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFSmartfeed`.
   */
  public static getModelName() {
    return "SFSmartfeed";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFSmartfeed for dynamic purposes.
  **/
  public static factory(data: SFSmartfeedInterface): SFSmartfeed{
    return new SFSmartfeed(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFSmartfeed',
      plural: 'SFSmartfeeds',
      path: 'SFSmartfeeds',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFSmartfeed.ts